const ContentTypeManagerStyles = {
  container: {
    // padding: 2,
  },
  header: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 3,
  },
};

export default ContentTypeManagerStyles;
